"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var joinApi_1 = __importDefault(require("../mock/joinApi"));
var tournamentsServiceUrl = process.env.CB_SERVER_URL;
var tournamentsApi = {
    joinTournament: function (token, tournamentUuid) {
        if (tournamentUuid === void 0) { tournamentUuid = ''; }
        return rest_1.default.patch({
            mockFunc: function () { return joinApi_1.default; },
            url: "".concat(tournamentsServiceUrl, "/learning-panel/join-tournament/").concat(tournamentUuid),
            token: token,
        });
    },
};
exports.default = tournamentsApi;
